<template>
  <tr tabindex="0">
    <td
      :style="tdStyle"
      align="center"
      class="cursor-move hover:outline-dashed hover:outline-offset-[-1px] hover:outline-gray-100"
      :class="{
        'outline-dashed outline-offset-[-1px] outline-gray-100': dragging,
      }"
    >
      <table
        role="presentation"
        cellpadding="0"
        cellspacing="0"
        style="border-collapse: collapse; border-spacing: 0px"
        :align="align"
        border="0"
      >
        <tbody>
          <tr>
            <td :style="wrapperStyle">
              <a :href="link" @click.prevent="">
                <img
                  :id="id"
                  :alt="alt"
                  title=""
                  height="auto"
                  :src="src"
                  :style="imageStyle"
                  :width="block.attributes['image-width']"
                  class="cursor-move"
                />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script lang="ts" setup>
  import { StyleValue, computed } from "vue";
  import { useMjmlStore } from "@/stores/mjmlStore";

  const mjmlStore = useMjmlStore();

  const props = defineProps({
    block: {
      type: Object,
      required: true,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
    columnIndex: {
      type: Number,
      required: true,
    },
    blockIndex: {
      type: Number,
      required: true,
    },
    loopColumnIndex: {
      type: Number,
      required: true,
    },
    loopBlockIndex: {
      type: Number,
      required: true,
    },
    dragging: {
      type: Boolean,
      default: false,
    },
  });

  const id = computed(() => {
    return "img" + props.block.uid;
  });

  const align = computed(() => {
    return props.block.attributes["align"]
      ? props.block.attributes["align"]
      : "center";
  });

  const padding = computed(() => {
    return props.block.attributes["padding"]
      ? props.block.attributes["padding"]
      : "0px 0px 0px 0px";
  });

  const awsFolder = computed(() => {
    return import.meta.env.VITE_APP_AWS_FOLDER;
  });

  const src = computed(() => {
    return `${awsFolder.value}/assets/images/merge-tags/dummy.svg`;
  });

  const alt = computed(() => {
    if (props.block.attributes["alt"]) {
      return props.block.attributes["alt"];
    }
    if (props.block.attributes["title"]) {
      return props.block.attributes["title"].replace(
        /<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g,
        ""
      );
    }
    return "";
  });

  const link = computed(() => {
    return props.block.attributes["href"];
  });

  const tdStyle = computed<StyleValue>(() => {
    return {
      padding: padding.value,
      "word-break": "break-word",
      "font-size": "0px",
    };
  });

  const wrapperStyle = computed<StyleValue>(() => {
    let width =
      (props.block.attributes["width"]
        ? props.block.attributes["width"]
        : props.block.attributes["containerWidth"]) + "px";
    if (
      mjmlStore.isMobileFirstEnabled &&
      mjmlStore.isMobileView &&
      props.block.attributes["fluid-on-mobile"] === "true"
    ) {
      width = "100%";
    }
    return {
      width: width,
    };
  });

  const imageStyle = computed<StyleValue>(() => {
    return {
      border: "none",
      "border-radius": props.block.attributes["border-radius"] || "0px",
      display: "block",
      outline: "none",
      "text-decoration": "none",
      width: "100%",
      height: "auto",
    };
  });
</script>
